import { render, staticRenderFns } from "./PgaTooltipIcon.vue?vue&type=template&id=682f1ebc&"
import script from "./PgaTooltipIcon.vue?vue&type=script&lang=ts&"
export * from "./PgaTooltipIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VIcon,VTooltip})


/* hot reload */
if (module.hot) {
  var api = require("/src/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('682f1ebc')) {
      api.createRecord('682f1ebc', component.options)
    } else {
      api.reload('682f1ebc', component.options)
    }
    module.hot.accept("./PgaTooltipIcon.vue?vue&type=template&id=682f1ebc&", function () {
      api.rerender('682f1ebc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PgaTooltipIcon.vue"
export default component.exports